
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.611 4.489a.9.9 0 100 1.8.9.9 0 000-1.8zm-2.4.9a2.4 2.4 0 114.8 0 2.4 2.4 0 01-4.8 0zM5.39 17.71a.9.9 0 100 1.8.9.9 0 000-1.8zm-2.4.9a2.4 2.4 0 114.8 0 2.4 2.4 0 01-4.8 0zM16 9.001a.75.75 0 00-1.062-1.061l-6.997 7.003a.75.75 0 101.061 1.06L16.001 9z"}})])
          )
        }
      }
    